export default async function saveSearchParams() {
  sessionStorage.setItem('init-search', window.location.search)
}
